module.exports = __webpack_public_path__ + "img/m.db6a9caa.jpg";